import { render, staticRenderFns } from "./BgFilter.vue?vue&type=template&id=0a696dfb&scoped=true&"
import script from "./BgFilter.vue?vue&type=script&lang=js&"
export * from "./BgFilter.vue?vue&type=script&lang=js&"
import style0 from "./BgFilter.vue?vue&type=style&index=0&id=0a696dfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a696dfb",
  null
  
)

component.options.__file = "BgFilter.vue"
export default component.exports